import { render, staticRenderFns } from "./promotions.vue?vue&type=template&id=a44a9456&"
import script from "./promotions.vue?vue&type=script&lang=js&"
export * from "./promotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports